export enum TabIds {
  OVERVIEW = 0,
  HOTSPOT = 1,
  BLOCKCHAIN = 2,
}
